/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import * as yup from 'yup'

export const userModel = (intl, create) => {
    let schema = yup.object().shape({
        userName: yup.string()
            .required(intl.formatMessage({id: "user.schema.userName.required"}))
            .trim().matches(/^[A-Za-z0-9_\-\.@]+$/, intl.formatMessage({id: "user.schema.userName.format"}))
            .trim().min(3, intl.formatMessage({id: "user.schema.userName.minSize"}))
            .trim().max(50, intl.formatMessage({id: "user.schema.userName.maxSize"})),
        firstName: yup.string()
            .required(intl.formatMessage({id: "user.schema.firstName.required"}))
            .trim().min(1, intl.formatMessage({id: "user.schema.firstName.blank"}))
            .trim().max(50, intl.formatMessage({id: "user.schema.firstName.maxSize"})),
        lastName: yup.string()
            .required(intl.formatMessage({id:"user.schema.lastName.required"}))
            .trim().min(1, intl.formatMessage({id:"user.schema.lastName.blank"}))
            .trim().max(50, intl.formatMessage({id:"user.schema.lastName.maxSize"})),
        middleName: yup.string()
            .trim().max(50, intl.formatMessage({id:"user.schema.middleName.maxSize"})),
        email: yup.string()
            .email(intl.formatMessage({id:"user.schema.email.valid"}))
            .trim().min(1, intl.formatMessage({id: "user.schema.email.blank"}))
            .trim().max(80, intl.formatMessage({id: "user.schema.email.maxSize"})),
        roles: yup.array().min(1, intl.formatMessage({id: "user.schema.roles.min"}))
            .required(intl.formatMessage({id: "user.schema.roles.required"}))
            .of(yup.object({
                id: yup.number()
                    .required(intl.formatMessage({id: "user.schema.role.id.required"}))
                    .typeError(intl.formatMessage({id: "user.schema.role.id.required"}))
                    .positive(intl.formatMessage({id: "user.schema.role.id.required"})),
                fleets: yup.array()
                    .min(1, intl.formatMessage({id: "user.schema.fleets.min"})),
            })),
    })

    if (create) {
        //extend validation schema about password
        schema = schema.shape({
            password: yup.string()
                .required(intl.formatMessage({id: "user.schema.password.required"}))
                .trim().min(6, intl.formatMessage({id: "user.schema.password.min"}))
                .trim().max(72, intl.formatMessage({id: "user.schema.password.max"})),
            confirmPassword: yup.string()
                .equalTo(yup.ref('password'), 'Passwords must match')
                .required(intl.formatMessage({id: "user.schema.password.required"})),
        })
    } else {
        //extend validation schema about id
        schema = schema.shape({
            id: yup.number().required(),
            password: yup.string()
                .trim().min(6, intl.formatMessage({id: "user.schema.password.min"}))
                .trim().max(72, intl.formatMessage({id: "user.schema.password.max"})),
            confirmPassword: yup.string()
                .equalTo(yup.ref('password'), 'Passwords must match'),
        })


    }

    return schema
}

//adds a special method to check if a field has same value as a field in ref parameter
const equalTo = (ref, msg) => {
    return yup.mixed().test({
        name: 'equalTo',
        exclusive: false,
        message: msg || '${path} must be the same as ${reference}',
        params: {
            reference: ref.path,
        },
        test: function (value) {
            return value === this.resolve(ref);
        },
    });
}

yup.addMethod(yup.string, 'equalTo', equalTo);

